<template>
    <div id="container" :class="['sub-container', !showBtm ? 'nav_close' : '']">
        <div class="container_inner">
            <div class="pc-visible sub_top_title" style="z-index: 9; height: 38px; margin: 10px auto;">
                <h3 style="padding: 4px 0 0 24px;">실시간 도시 현황</h3>
            </div>
            <!-- <div v-show="showTxt">
                <h3 style="padding-top:0px;">{{ disasterText.basdtVal | ymdhs }}</h3>
                <h3 style="padding-top:0px;">{{ disasterText.val4 }}</h3>
            </div> -->
            <div class="realtime_map">
                <div class="map_area_c m-visible" style="z-index: 9;">
                    <h3>실시간 도시 현황</h3>
                </div>
                <NaverMapWrap />
                <SafetyMapCtrl />
                <AccidentMapCtrl />
                <AirMapCtrl />
                <WaterMapCtrl />
                <RealtimeMapCtrl />
                <RealtimeMenuPanel />
                <RealtimeLegend />
                <SeoulSimpleMap />
                <SeoulSimpleMapCtrl />
                <FacilityMapCtrl />

                <SeoulmapMapCtrl />
                <SeoulmapMarkerMapCtrl />
                <SeoulmapRoadMapCtrl />
            </div>
            <div class="data_area" v-show="showRealcityPop">
                <RealtimeChart />
                <SafetyTab v-show="['Safety', 'Realcity'].includes(selectedTopMenu)" />
                <SafetyList v-show="['Safety', 'Realcity'].includes(selectedTopMenu)" />
                <AccidentList v-show="selectedTopMenu === 'Accident'" />
                <AirList v-show="selectedTopMenu === 'Air'" />
                <WaterList v-show="selectedTopMenu === 'Water'" />
            </div>
            
            <SeoulmapDetailWin v-show="['Realcity'].includes(selectedTopMenu)"></SeoulmapDetailWin>
        </div>


    	<PulseLoader :loading="loading" :add-style="'width:100%; height:100%; top: 0px; left: 0px;'"></PulseLoader>
    </div>
</template>

<script>
import NaverMapWrap from '@/components/NaverMapWrap.vue';
import RealtimeMenuPanel from '@/views/realtime/RealtimeMenuPanel.vue';
import SafetyMapCtrl from '@/views/realtime/SafetyMapCtrl.vue';
import AccidentMapCtrl from '@/views/realtime/AccidentMapCtrl.vue';
import AirMapCtrl from '@/views/realtime/AirMapCtrl.vue';
import WaterMapCtrl from '@/views/realtime/WaterMapCtrl.vue';
import FacilityMapCtrl from '@/views/realtime/FacilityMapCtrl.vue';
import SafetyList from '@/views/realtime/SafetyList.vue';
import AccidentList from '@/views/realtime/AccidentList.vue';
import AirList from '@/views/realtime/AirList.vue';
import WaterList from '@/views/realtime/WaterList.vue';
import RealtimeChart from '@/views/realtime/RealtimeChart.vue';
import SeoulSimpleMap from '@/views/realtime/SeoulSimpleMap.vue';
import RealtimeMapCtrl from '@/views/realtime/RealtimeMapCtrl.vue';
import SeoulSimpleMapCtrl from '@/views/realtime/SeoulSimpleMapCtrl.vue';
import RealtimeLegend from "@/views/realtime/RealtimeLegend";
import SafetyTab from "@/views/realtime/SafetyTab";
import PulseLoader from '@/views/common/PulseLoader.vue';


import SeoulmapMapCtrl from '@/views/realtime/SeoulmapMapCtrl.vue';
import SeoulmapMarkerMapCtrl from '@/views/realtime/SeoulmapMarkerMapCtrl.vue';
import SeoulmapRoadMapCtrl from '@/views/realtime/SeoulmapRoadMapCtrl.vue';
import SeoulmapDetailWin from '@/views/realtime/SeoulmapDetailWin.vue';

import { mapGetters } from 'vuex';
import { $_WC } from '@/confs/common.const';

export default {
    name: 'Realtime',
    components: {
        NaverMapWrap,
        RealtimeMenuPanel,
        SafetyMapCtrl,
        AccidentMapCtrl,
        AirMapCtrl,
        WaterMapCtrl,
        FacilityMapCtrl,
        SafetyList,
        AccidentList,
        AirList,
        WaterList,
        RealtimeChart,
        SeoulSimpleMap,
        RealtimeMapCtrl,
        SeoulSimpleMapCtrl,
        RealtimeLegend,
        SafetyTab,
        SeoulmapMapCtrl,
        SeoulmapMarkerMapCtrl,
        SeoulmapRoadMapCtrl,
        SeoulmapDetailWin,
        PulseLoader,
    },
    data() {
        return {
            loading: false,
            showRealcityPop: true,
        }
    },
    computed: {
        ...mapGetters({
            selectedTopMenu: 'getSelectedTopMenu',
            showBtm: 'getShowBtm',
            // disasterTxt: 'getDisasterTxt',
        }),
        // disasterText() {
        //     let txt = '';
        //     if(typeof this.disasterTxt !== 'undefined' && this.disasterTxt.length > 0) {
        //         txt = this.disasterTxt[0];
        //         this.showTxt = true;
        //     }
        //     return txt;
        // }
    },
    created() {
    },
    mounted() {
        this.$eventBus.$on("ChangeLoading::State::Loading", () => {
            this.loading = true;
        });
        this.$eventBus.$on("ChangeLoading::State::Loaded", () => {
            this.loading = false;
        });
        this.$eventBus.$on('SeoulmapMapCtrl::realcity-map-button-style', (popState) => {
            if(this.selectedTopMenu == 'Realcity' && $_WC.viewScale == 1 && !$_WC.isMobile) {
                this.showRealcityPop = !popState;
            } else {
                this.showRealcityPop = true;
            }
        });
    },
    methods: {

    },
};
</script>
<style>
@media (min-width: 1020px) and (max-width: 1921px) {
    .realtime_map{
       width: 67%;
       height: 640px;
       margin: 0 auto;
       float: left;
       left: 15px;
    }
    .data_area{
    /*    !*width: calc(30% - 25px);*!*/
       top: -20px;
       width: 30%;
       padding: 0px;
       display: block;
       float: right;
       right: 15px;
    }
    .data_population {
        width: 100%;
        margin: 0px;
        position: relative;
    }
    .data_population.mt-20 {
        position: absolute;
    }
    .data_population.bottom {
       top: 325px;
    }
    .grph_area{ height: 285px;}
    .tb_st01 .tbody {height: 235px;}
}
</style>
